// Devuelve el texto en el idioma pedido si el valor es { es, en }; si es un texto único, lo devuelve tal cual.
export const pick = (value, lang) =>
  value && typeof value === 'object' && !Array.isArray(value) ? value[lang] ?? value.es : value;
